import type { IResource, ISchedule } from "@gettactic/api";

/**
 * The resource the edit form has to start from.
 *
 * Saving an edited room reservation swaps the reservation's primary room — the one on
 * `schedule.resource` — for whatever the form points at (see
 * `getEditedReservationRoomIds`), so the form has to start from that exact room. Slot
 * order does not identify it: the API returns the slots unordered, so the first room
 * slot is not necessarily the primary. Starting from another room made a save that
 * changed nothing rewrite the primary as a room the reservation already held, collapsing
 * the two into one and dropping a room.
 *
 * Only room reservations are realigned. Anything else keeps `slotPrimary`, so the
 * resource type the rest of the form is built around never changes.
 *
 * @param slotPrimary the resource picked out of the slots by type priority
 */
export const getEditedReservationPrimaryResource = (
  schedule: ISchedule,
  slotPrimary: IResource
): IResource =>
  slotPrimary.type === "meeting_room" &&
  schedule.resource?.type === "meeting_room"
    ? schedule.resource
    : slotPrimary;
